import { Spinner, Stack, Typography } from "@altimateai/lego";

export interface LoaderProps {
  label?: string;
}

export const Loader = ({ label }: LoaderProps) => (
  <Stack direction="column" align="center" justify="center" className="al-py-8">
    <Spinner />
    {label && (
      <Typography variant="body" className="al-text-muted-foreground al-mt-2">
        {label}
      </Typography>
    )}
  </Stack>
);
